import { fetcher } from '@commenda/utils';

import { IExternalShare, IUpdateFileShareRequest } from './types';

export const updateFileShare = async (
  id: string,
  body: IUpdateFileShareRequest
): Promise<{ share: IExternalShare }> => {
  const res = await fetcher(`file-shares/${id}`, { method: 'POST', body });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || 'Failed to update share link.');
  }
  return await res.json();
};
